import { Container, Box } from 'src/components-v2/Layout';
import TableHeader from './TableHeader';
import TableRow, { ProductRow } from './TableRow';
import TableFooter from './TableFooter';
import Disclaimer from './Disclaimer';
import HideFromUser from 'src/components-v2/Helpers/HideFromUser/HideFromUser';

const PRODUCT_LIST: ProductRow[] = [
  {
    productName: 'Auth',
    description: 'Help customers fund accounts faster',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/auth/',
  },
  {
    productName: 'Balance',
    description: 'Instantly confirm account balances',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/balance/',
  },
  {
    productName: 'Identity',
    description: 'Verify bank account ownership',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/identity/',
  },
  {
    productName: 'Identity Match',
    description: 'Match bank account ownership',
    payAsYouGo: true,
    growth: true,
    custom: true,
  },
  {
    productName: 'Investments Move',
    description: 'Authorize investment transfers',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/investments-move/',
  },
  {
    productName: 'Assets',
    description: 'Access financial data for underwriting',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/assets/',
  },
  {
    productName: 'Income',
    description: 'Verify income and paystubs',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/income/',
  },
  {
    productName: 'Statements',
    description: 'Refresh statements by date',
    payAsYouGo: true,
    growth: true,
    custom: true,
  },
  {
    productName: 'Enrich',
    description: 'Clean up raw transaction data',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/enrich/',
  },
  {
    productName: 'Investments',
    description: 'Get a holistic view of investments',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/investments/',
  },
  {
    productName: 'Liabilities',
    description: 'Easily understand customer debt',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/liabilities/',
  },
  {
    productName: 'Transactions',
    description: 'Access 24 months of transaction data',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/transactions/',
  },
  {
    productName: 'Identity Verification',
    description: 'Verify good users and stop bad ones',
    payAsYouGo: true,
    growth: true,
    custom: true,
    url: '/products/identity-verification/',
  },
  {
    productName: 'Monitor',
    description: 'Stay AML and PEP compliant',
    payAsYouGo: true,
    growth: true,
    custom: true,

    url: '/products/monitor/',
  },
  {
    productName: 'Layer',
    description: 'Onboard customers instantly',
    payAsYouGo: false,
    growth: 'contact',
    custom: true,
    url: '/layer/',
  },
  {
    productName: 'Signal',
    description: 'Prevent NSFs and other returns',
    payAsYouGo: false,
    growth: 'contact',
    custom: true,
    url: '/products/signal/',
  },
  {
    productName: 'Transfer',
    description: 'Transfer money between accounts',
    payAsYouGo: false,
    growth: 'contact',
    custom: true,
    url: '/products/transfer/',
  },
  {
    productName: 'Consumer Report',
    description: 'Get risk insights for underwriting',
    payAsYouGo: false,
    growth: 'contact',
    custom: true,
    url: '/check/income-and-underwriting/',
  },
  {
    productName: 'Protect',
    description: 'Fraud intelligence system',
    payAsYouGo: false,
    growth: 'contact',
    custom: true,
    url: '/products/protect/',
  },
];

const getPlanText = (plan: boolean | string) => {
  if (plan === true) {
    return 'Included';
  } else if (plan === 'contact') {
    return 'Contact for pricing';
  } else {
    return 'Not included';
  }
};

const ProductTable = () => {
  return (
    <Container
      sx={{
        position: 'relative',
      }}
    >
      <Box className='hide-for-aeo'>
        <TableHeader />
        {PRODUCT_LIST.map((product, index) => {
          return <TableRow key={index} {...product} />;
        })}
        <TableFooter />
      </Box>
      {/*
        HEY! HI! HELLO! PLEASE DO NOT FORGET TO UPDATE THE BELOW TABLE
        ==============================================================
        All of our pages are now compiled to markdown for answer engine optimization (AEO).
        Ideally everything we build is built with semantics in mind, but in this case refactoring
        the pricing table would be too much work. So we're left with maintaining two versions of the table.
        One for AEO and one for humans.
      */}
      <HideFromUser>
        <table>
          <thead>
            <tr>
              <th>Products</th>
              <th>Pay as You Go</th>
              <th>Growth</th>
              <th>Custom</th>
            </tr>
          </thead>
          <tbody>
            {PRODUCT_LIST.map((product, index) => {
              return (
                <tr key={index}>
                  <td>
                    <a href={product.url} title={product.description}>
                      {product.productName}
                    </a>
                  </td>
                  <td>{getPlanText(product.payAsYouGo)}</td>
                  <td>{getPlanText(product.growth)}</td>
                  <td>{getPlanText(product.custom)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </HideFromUser>
      <Disclaimer />
    </Container>
  );
};

export default ProductTable;
